import React from "react";
import createReactClass from "create-react-class";
import moment from "moment";
import { Button } from "react-bootstrap";
import { AdminActions } from "../../actions/adminActions";

export const AdminRow = createReactClass({
  expireTimer: null,
  getInitialState: function () {
    return { timerActive: false };
  },
  onInputBlur: function (e) {
    var idParts = e.target.id.split("_");
    AdminActions.cellValueChanged(idParts[1], idParts[0], e.target.value);
  },
  expireOnClick: function (e) {
    var overrideId = e.target.id;

    window
      .confirm("Confirm Expiration", {
        description:
          "Are you sure you want to expire this override permission?",
        confirmLabel: "Expire Permission",
        abortLabel: "Cancel",
      })
      .then(function () {
        AdminActions.expireExistingOverride({ id: overrideId });
      });
  },
  refresh: function () {
    console.log("refreshing", this.props.item);
    this.setState({ timerActive: false });
  },
  render: function () {
    var item = this.props.item;
    if (this.props.type == "/defaultTracks") {
    } else {
      var mediumInput = { width: "100px" };
      var shortInput = { width: "25px" };
      var button = <div />,
        timeLeft = "",
        rowStyle = {};

      if (item.expireTimeStamp.isAfter(moment()) && item.numberSubmitted == 0) {
        button = (
          <Button
            id={item.id}
            bsSize="xsmall"
            bsStyle="danger"
            onClick={this.expireOnClick}
          >
            Expire Now
          </Button>
        );
        rowStyle = { background: "lightcoral" };

        var miliseconds = item.expireTimeStamp.diff(moment());
        var seconds = Math.floor((miliseconds / 1000) % 60);
        var minutes = Math.floor((miliseconds / 1000 / 60) % 60);

        timeLeft = ("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2);
      }

      return (
        <tr style={rowStyle}>
          <td>{item.userId}</td>
          <td>{item.subdivision}</td>
          <td>
            {item.startMp}
            {item.startMpSuffix}
          </td>
          <td>
            {item.endMp}
            {item.endMpSuffix}
          </td>
          <td>{item.minuteLimit}</td>
          <td>
            {item.reasonCode}:{item.reasonDescription}
          </td>

          <td>{item.createUserId}</td>
          <td>{item.createTimeStamp.format("HH:mm YYYY-MM-DD")}</td>
          <td>{item.expireTimeStamp.format("HH:mm YYYY-MM-DD")}</td>
          <td>{timeLeft}</td>
          <td>{button}</td>
        </tr>
      );
    }
  },
});

function getRowControls(item, type) {
  switch (type) {
    case AdminTypes.OVERRIDE_USER:
      return overrideUserControls(item);
  }
}
